import { useCallback, useState } from "react";
/**
 * @export
 * hook for refresh counter
 * this can be used to force re-render a component.
 */
const useCounter = () => {
    const [counter, setCounter] = useState(0);
    const updateCounter = useCallback(() => {
        setCounter(prev => (prev + 1));
    }, []);
    return {
        counter,
        updateCounter
    };
};
export default useCounter;
